import './_stacked-bar-chart.scss';

import sumBy from 'lodash/sumBy';
import { arrayOf, node, number, oneOfType, shape, string } from 'prop-types';
import React from 'react';
import { UncontrolledTooltip } from 'reactstrap';

function StackedBarChart({
  items,
  thickness,
  leftLabel,
  rightLabel,
  marker,
  markerHeight,
  id,
}) {
  const total = sumBy(items, 'value');

  function getWidth(value) {
    return `${(value / total) * 100}%`;
  }

  function getMarker() {
    const top = -(markerHeight - thickness) / 2;

    return (
      <div
        className="c-stacked-bar-chart__marker position-absolute bg-secondary"
        style={{
          left: getWidth(marker.value),
          height: `${markerHeight}px`,
          top: `${top}px`,
        }}
      >
        <div className="c-stacked-bar-chart__marker-label position-absolute text-nowrap">
          {marker.label}
        </div>
      </div>
    );
  }

  return (
    <div
      className="c-stacked-bar-chart d-flex align-items-center position-relative"
      style={{
        height: Math.max(thickness, markerHeight),
      }}
    >
      <div className="c-stacked-bar-chart__content w-100">
        <div className="c-stacked-bar-chart__labels position-absolute d-flex justify-content-between pr-2 w-100">
          <div>{leftLabel}</div>
          <div>{rightLabel}</div>
        </div>
        <div className="d-flex position-relative">
          {marker && getMarker()}
          {items.map(({ value, color, border, name, label }) => {
            const width = getWidth(value);
            const target = `stackedBar-${id}-${name}`;
            return (
              <div
                key={target}
                className={`c-stacked-bar-chart__bar bg-${color}`}
                id={target}
                style={{ width, border, height: `${thickness}px` }}
              >
                {label && (
                  <UncontrolledTooltip target={target} placement="bottom">
                    {label}
                  </UncontrolledTooltip>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

StackedBarChart.propTypes = {
  id: string.isRequired,
  thickness: number,
  items: arrayOf(
    shape({
      name: string.isRequired,
      value: number.isRequired,
      color: string.isRequired,
      border: string,
    }),
  ).isRequired,
  leftLabel: oneOfType([string, node]),
  rightLabel: oneOfType([string, node]),
  marker: shape({
    value: number.isRequired,
    label: oneOfType([string, node]),
  }),
  markerHeight: number,
};

StackedBarChart.defaultProps = {
  thickness: 12,
  leftLabel: '',
  rightLabel: '',
  marker: undefined,
  markerHeight: 72,
};

export default StackedBarChart;
